import { render, staticRenderFns } from "./GooglePlaces.vue?vue&type=template&id=4d54effe&"
import script from "./GooglePlaces.vue?vue&type=script&lang=js&"
export * from "./GooglePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports